import React, { useRef, useEffect, useState } from "react";

const displayOptions = [
  "Main Location",
  "Status",
  "Email",
  "Mobile",
  "Stress Profile",
  "Pay Rates",
  "Payroll ID",
  "Leave Balance",
  "Connected to",
];

export default function DisplayDropdown({ selected, onChange }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleOption = (option) => {
    const updated = selected.includes(option)
      ? selected.filter((item) => item !== option)
      : [...selected, option];
    onChange(updated);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener("pointerdown", handleClickOutside);
    return () =>
      document.removeEventListener("pointerdown", handleClickOutside);
  }, [open]);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="px-3 py-2 text-sm border rounded-md bg-white text-gray-700 border-gray-300 hover:bg-gray-50 flex items-center gap-1"
      >
        Display
        <svg
          className="w-4 h-4 text-gray-500"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {open && (
        <div className="absolute left-0 mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-lg z-50 py-2">
          {displayOptions.map((option) => (
            <label
              key={option}
              className="flex items-center px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100"
            >
              <input
                type="checkbox"
                checked={selected.includes(option)}
                onChange={() => toggleOption(option)}
                className="mr-2 accent-gray-600"
              />
              {option}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
